"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useUserContext = useUserContext;
exports.UserContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var UserContext = _react["default"].createContext({
  // This context value should be never used, always overridden in a provider.
  navigation: {
    expanded: false
  },
  setSidebarExpanded: _noop["default"]
}); // UserContext helpers


exports.UserContext = UserContext;

function useUserContext() {
  return (0, _react.useContext)(UserContext);
}